import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Light Icon Style 01 - Lightbulb (Material Symbol)
 * - isOn = true: 橙黃色實心燈泡 (FILL: 1)
 * - isOn = false: 灰色空心燈泡 (FILL: 0)
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:lightbulb
 */
export const Style01_Lightbulb: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-amber-500' : 'text-slate-400';
  
  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      lightbulb
    </span>
  );
};

export default Style01_Lightbulb;
